import { desktopPreferences, setDesktopPreference } from './electron-bridge';

type PendingValue = { id: number; value: string };
const pendingValues = new Map<string, PendingValue>();
let nextWriteId = 0;

/** Read a device preference from Desktop's stable store or localStorage on the web. */
export function readDevicePreference(key: string): string | null {
  const pending = pendingValues.get(key);
  if (pending !== undefined) return pending.value;
  const native = desktopPreferences();
  if (native !== null) {
    const value = native[key] ?? null;
    if (value !== null) {
      try {
        if (localStorage.getItem(key) !== value) localStorage.setItem(key, value);
      } catch {
        // The native store remains authoritative when browser storage is unavailable.
      }
    }
    return value;
  }
  return localStorage.getItem(key);
}

/** Keep localStorage as a web-compatible cache while making Desktop durable across origins. */
export async function writeDevicePreference(key: string, value: string): Promise<void> {
  localStorage.setItem(key, value);
  if (desktopPreferences() === null) return;
  const pending = { id: ++nextWriteId, value };
  pendingValues.set(key, pending);
  try {
    await setDesktopPreference(key, value);
  } finally {
    if (pendingValues.get(key)?.id === pending.id) pendingValues.delete(key);
  }
}
